<template>
    <div class="Handsfree" :class="{ disable : disable }">  
      <div class="Handsfree__hand ">{{ lft_locked }}</div>
      <div class="Handsfree__hand right">{{ rgt_locked }}</div>  
    </div>
</template>

<script>

import gsap from "gsap"
import Handsfree from 'handsfree'

export default {

  name: 'HandsFree',
  render: h => h(), 
  data: ()=>({

    fdl: 0,
    fdr: 0,
    plx: 0,
    prx: 0,
    nwl: 0,
    nwr: 0,
    lft_locked : false,
    rgt_locked: false,
    disable: false

  }),
  beforeDestroy() {
    if(this.rafID)
      cancelAnimationFrame(this.rafID)
    this.removeHandsFree()
  },
  mounted() {
    this.$handsfree = new Handsfree({ showDebug: false, hands: {
        enabled: true,
        maxNumHands: 2,
        minDetectionConfidence: 0.5,
        minTrackingConfidence: 0.5
      }
    })
    this.$handsfree.enablePlugins('browser')


    this.$handsfree.model.handpose.disable()
    this.$handsfree.model.weboji.disable()
    
    // handsfree.model.hands.enable()

    this.$handsfree.start()
    this.onLoop()

    console.log('HandsFree');

  },
  methods: {

    removeScreens() {
      console.log('x');
      gsap.set('.handsfree-debugger', { 'display' : 'none' })
    },

    removeHandsFree() {
      // TODO . 
    },
    motionLeft() {
      if(this.lft_locked == true)
        return
      this.lft_locked = true
      this.$store.commit('app/MOTION_LEFT')
      gsap.delayedCall(.35, ()=>{ this.lft_locked = false })
    },
    motionRight() {
      if(this.rgt_locked == true)
        return
      this.rgt_locked = true
      this.$store.commit('app/MOTION_RIGHT')
      gsap.delayedCall(.35, ()=>{ this.rgt_locked = false })
    },
    onLoop(delta) {
      
      if(this.$handsfree.data.hands) { 

        // LEFT HAND

        if(this.$handsfree.data.hands.landmarksVisible[0]) {  
          this.nwl = Math.round((this.plx - this.$handsfree.data.hands.landmarks[0][0]['x'])*100)
          if(this.nwl > 2 && this.fdl > 5)
            this.motionLeft()
          this.plx = this.$handsfree.data.hands.landmarks[0][0]['x']
          this.fdl = this.fdl == 10 ? 10 : this.fdl += 1
        }
        else {
          this.fdl -=1
          if(this.fdl < 0)
            this.fdl = 0
        }

        // RIGHT HAND

        if(this.$handsfree.data.hands.landmarksVisible[1]) {
          this.nwr = Math.round((this.pdx - this.$handsfree.data.hands.landmarks[1][0]['x'])*100)
          if(this.nwr < -2 && this.fdr > 5) 
            this.motionRight()
          this.pdx = this.$handsfree.data.hands.landmarks[1][0]['x']
          this.fdr = this.fdr == 10 ? 10 : this.fdr += 1
        }
        else {
          this.fdr -=1
          if(this.fdr < 0)
            this.fdr = 0
        }
      }

      this.rafID = requestAnimationFrame(this.onLoop)   
    },

  }
}
</script>

<style lang="stylus">

@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.Handsfree
  position absolute 
  top 0 
  left 0
  width 100vw

  &__hand 
    position absolute
    border 1px solid red
    padding 4px 16px
    width 300px
    background red
    text-align center
    height 27px

    &.right 
      right 0
      
</style>















